import { buildRequestDataToBytes } from '@/proto/helper.js';

export default (obj) => {
  const { baseUrl, onOpen, onMessage, onError, onClose } = obj;

  let timer = null;

  const ws = new WebSocket(baseUrl);
  ws.binaryType = 'arraybuffer';
  ws.addEventListener('open', onOpen);
  ws.addEventListener('message', onMessage);
  ws.addEventListener('error', onError);
  ws.addEventListener('close', onClose);


  return ws;
};
